var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnColors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 19.4717C12.0615 20.4218 13.4633 20.9995 15 20.9995C18.3137 20.9995 21 18.3132 21 14.9995C21 12.2037 19.0879 9.85458 16.5 9.18848",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.18848C2.91216 9.85458 1 12.2037 1 14.9995C1 18.3132 3.68629 20.9995 7 20.9995C10.3137 20.9995 13 18.3132 13 14.9995C13 14.2247 12.8532 13.4843 12.5858 12.8045",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13C14.3137 13 17 10.3137 17 7C17 3.68629 14.3137 1 11 1C7.6863 1 5 3.68629 5 7C5 10.3137 7.6863 13 11 13Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnColors);
export default __webpack_public_path__ + "static/media/icn-colors.5d6e75f0d684f0cc818e20336dd6ae1c.svg";
export { ForwardRef as ReactComponent };